<template>
  <div class="quick-scoring-panel" v-if="visible">
    <div class="panel-overlay" @click="$emit('close')"></div>
    <div class="panel-content">
      <div class="panel-header">
        <h4>Quick Score: {{ currentCriterion.description }}</h4>
        <button @click="$emit('close')" class="close-btn">×</button>
      </div>
      
      <div class="scoring-options">
        <button
          v-for="score in scoreOptions"
          :key="score"
          @click="$emit('quick-score', score)"
          class="quick-score-btn"
          :class="getScoreClass(score)"
        >
          <span class="score-number">{{ score }}</span>
          <span class="score-label">{{ getScoreLabel(score) }}</span>
        </button>
      </div>
      
      <div class="criterion-info">
        <p><strong>Max Score:</strong> {{ currentCriterion.maxScore }}</p>
        <p v-if="currentCriterion.exampleFeedback">
          <strong>Example:</strong> {{ currentCriterion.exampleFeedback }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentCriterion: Object,
    visible: Boolean
  },
  
  computed: {
    scoreOptions() {
      if (!this.currentCriterion) return [];
      return Array.from({ length: this.currentCriterion.maxScore + 1 }, (_, i) => i);
    }
  },
  
  methods: {
    getScoreClass(score) {
      const percentage = (score / this.currentCriterion.maxScore) * 100;
      if (percentage >= 80) return 'excellent';
      if (percentage >= 60) return 'good';
      if (percentage >= 40) return 'average';
      return 'poor';
    },
    
    getScoreLabel(score) {
      const percentage = (score / this.currentCriterion.maxScore) * 100;
      if (percentage >= 80) return 'Excellent';
      if (percentage >= 60) return 'Good';
      if (percentage >= 40) return 'Average';
      if (percentage >= 20) return 'Below Avg';
      return 'Poor';
    }
  }
}
</script>

<style scoped>
.quick-scoring-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.panel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.panel-content {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.panel-header h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.1em;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.close-btn:hover {
  background: #e9ecef;
}

.scoring-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 10px;
  padding: 20px;
}

.quick-score-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 5px;
}

.quick-score-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.quick-score-btn.excellent {
  border-color: #28a745;
  color: #28a745;
}

.quick-score-btn.good {
  border-color: #17a2b8;
  color: #17a2b8;
}

.quick-score-btn.average {
  border-color: #ffc107;
  color: #ffc107;
}

.quick-score-btn.poor {
  border-color: #dc3545;
  color: #dc3545;
}

.quick-score-btn.excellent:hover {
  background: #28a745;
  color: white;
}

.quick-score-btn.good:hover {
  background: #17a2b8;
  color: white;
}

.quick-score-btn.average:hover {
  background: #ffc107;
  color: #212529;
}

.quick-score-btn.poor:hover {
  background: #dc3545;
  color: white;
}

.score-number {
  font-size: 1.5em;
  font-weight: 700;
}

.score-label {
  font-size: 0.8em;
  font-weight: 500;
}

.criterion-info {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  font-size: 0.9em;
  color: #6c757d;
}

.criterion-info p {
  margin: 5px 0;
}
</style>